import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function Register() {
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { register, error } = useAuth();
  const nav = useNavigate();

  const handle = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const ok = await register(email, password, username);
    setSubmitting(false);
    if (ok) nav("/feed", { replace: true });
  };

  return (
    <div data-testid="register-page" className="min-h-[70vh] px-6 md:px-12 py-16 grid md:grid-cols-2 gap-12 max-w-6xl mx-auto items-center">
      <div>
        <div className="font-mono-acc text-xs text-secondary">// NEW PRODUCER</div>
        <h1 className="font-display text-5xl md:text-6xl mt-4">Sign <span className="text-primary">up</span>.</h1>
        <p className="text-muted-foreground mt-4 max-w-md">Claim your handle. Upload your first beat. Get judged.</p>
      </div>
      <form onSubmit={handle} className="border border-border bg-card p-8 space-y-4">
        <label className="block">
          <span className="font-mono-acc text-[10px] text-muted-foreground">Producer handle</span>
          <input
            data-testid="register-username"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="lowercase, no spaces"
            className="mt-1 w-full bg-input border border-border px-3 py-3 outline-none focus:border-primary"
            required
            minLength={2}
            maxLength={30}
          />
        </label>
        <label className="block">
          <span className="font-mono-acc text-[10px] text-muted-foreground">Email</span>
          <input
            data-testid="register-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1 w-full bg-input border border-border px-3 py-3 outline-none focus:border-primary"
            required
          />
        </label>
        <label className="block">
          <span className="font-mono-acc text-[10px] text-muted-foreground">Password (min 6)</span>
          <input
            data-testid="register-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-1 w-full bg-input border border-border px-3 py-3 outline-none focus:border-primary"
            required
            minLength={6}
          />
        </label>
        {error && <p data-testid="register-error" className="text-primary text-sm font-mono-acc text-[11px]">{error}</p>}
        <button
          data-testid="register-submit"
          disabled={submitting}
          className="w-full border border-primary bg-primary text-white py-3 font-mono-acc text-xs hover:bg-white hover:text-primary disabled:opacity-50"
        >
          {submitting ? "Creating account..." : "Create Account"}
        </button>
        <p className="font-mono-acc text-[10px] text-muted-foreground">
          Got one already?{" "}
          <Link to="/login" data-testid="goto-login" className="text-secondary hover:underline">
            Log in
          </Link>
        </p>
      </form>
    </div>
  );
}
